/* eslint-disable import/no-anonymous-default-export */
import { LISTAR_ESTADOSCIVILES } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_ESTADOSCIVILES:
      return {
        ...state,
        estadosCiviles: action.payload,
      };

    default:
      return state;
  }
};
